/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AppAutobuildId } from "../../commons/types/AppAutobuildId";
import { AppAutobuildType } from "./AppAutobuildType";
export const AppAutobuild = core.serialization.object({
    id: AppAutobuildId,
    type: AppAutobuildType,
    fileName: core.serialization.string().optional(),
    fileExt: core.serialization.string().optional(),
    fileMimetype: core.serialization.string().optional(),
    fileEncoding: core.serialization.string().optional(),
    fileSize: core.serialization.number().optional(),
    fields: core.serialization.string().optional(),
    prompt: core.serialization.string().optional(),
    companyUrl: core.serialization.string().optional(),
});
